import React, { useEffect, useState } from 'react';
import ButtonTwo from '../../components/Button/ButtonTwo';
import SingleBlogTwo from '../../components/Blog/SingleBlogTwo';
import '../../assets/scss/components/custom.scss';

const Blog = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetch('https://ricgop.online/api/events.php')
      .then(res => res.json())
      .then(data => {
        const rawEvents = Array.isArray(data.events) ? data.events : Array.isArray(data) ? data : [];

        // 🔴 Exclude specific event IDs
        const excludedIds = [5, 6, 7, 8];
        const filteredEvents = rawEvents.filter(event => !excludedIds.includes(parseInt(event.id)));

        // ✅ Limit to 2 latest events after filtering
        setEvents(filteredEvents.slice(0, 2));
      })
      .catch(err => console.error('Failed to fetch events:', err));
  }, []);

  const stripHTML = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent || "";
  };

  return (
    <div
      id="it-blog"
      className="it-blog-2-area it-blog-style-3 p-relative pt-120 pb-90"
    >
      <div className="container">
        <div className="row gx-35 align-items-center">
          <div className="col-xl-4 col-lg-4 col-md-6">
            <div className="it-blog-title-box">
              <span className="it-section-subtitle red-border">Our Events</span>
              <h3 className="it-section-title">
                Our Latest <br /> News & Events
              </h3>
              <div className="it-blog-2-text mt-20 mb-40">
                <p>
                  Stay Updated With Our Latest News & Updates Of Events
                </p>
              </div>
              <ButtonTwo
                btnURL="/event"
                btnClass="it-btn-theme red-bg mr-35"
                btnText="All Events"
              />
            </div>
          </div>

          {events.map((event, index) => (
            <div
              key={event.id}
              className="col-xl-4 col-lg-4 col-md-6 mb-30"
              style={{
                height: '550px',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                paddingTop: 0,
                justifyContent: 'space-between',
                backgroundColor: '#f9f9f9',
              }}
            >
              <SingleBlogTwo
                id={event.id}
                blogImage={`/assets/img/${event.image_url}`}
                publishedDate={`${event.published_date} ${event.published_month}, ${new Date().getFullYear()}`}
                titleClass="hover-anim red"
                descriptionClass="pt-3"
                title={event.title}
                description={
                  event.short_description
                    ? stripHTML(event.short_description)
                    : stripHTML(event.content)?.slice(0, 80)
                }
                hasArrow
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
